import React, { useState } from 'react';
import copyIcon from '../../../../../../assets/image/copy_icon.svg';
import { copyToClipboard } from '../../../../../../utils/controller';
import moment from 'moment';

export default function UserDetails({ details }) {
	const [isShowPassword, setIsShowPassword] = useState(false);
	return (
		<div className="p-2">
			<div className="user-details-drawer">
				<div className="fs-4 fw-semibold text-dark p-3">{'Login Details'}</div>
				<div style={{ border: '1px solid #EFEFF4' }}></div>
				<div className="p-3">
					<div className="d-flex gap-4">
						<div
							className="fs-4 fw-bold"
							style={{ color: '#555B67', width: '110px' }}
						>
							{'Username'}
						</div>
						<div
							className="fs-4 fw-bold"
							style={{
								color: '#000',
							}}
						>
							{details.username}
						</div>
					</div>
					<div className="d-flex gap-4">
						<div
							className="fs-4 fw-bold"
							style={{ color: '#555B67', width: '110px' }}
						>
							{'Password'}
						</div>
						<div className="d-flex align-items-center gap-3">
							<div
								className="fs-4 text-center fw-bold"
								style={{
									color: '#000',
								}}
							>
								{isShowPassword ? details.password : '********'}
							</div>
							<i
								className={`fa ${isShowPassword ? 'fa-eye-slash' : 'fa-eye'}`}
								onClick={() => setIsShowPassword(!isShowPassword)}
								style={{ width: '18px', cursor: 'pointer' }}
							/>

							<img
								src={copyIcon}
								alt=""
								style={{ width: '18px', cursor: 'pointer' }}
								onClick={() => copyToClipboard(details.password)}
							/>
						</div>
					</div>
					<div className="d-flex gap-4">
						<div
							className="fs-4 fw-bold"
							style={{ color: '#555B67', width: '110px' }}
						>
							{'Last Logged In'}
						</div>
						<div
							className="fs-4 fw-bold"
							style={{
								color: '#000',
							}}
						>
							{moment(details.updated_at).format('MM/DD/YYYY hh:mm A')}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
